'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLogLevel = undefined;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 Ably Log Level

 Local Storage Override:  `ABLY_LOG_LEVEL`

 Note: By default in production we use DEBUG logging.  We do not print this to the console. 
 Instead, it is collected and sent to sentry if an error occurs.

 level: a number controlling the verbosity of the output. Valid values are:
 *  0 (no logs)
 *  1 (errors only)
 *  2 (errors plus connection and channel state changes)
 *  3 (high-level debug output)
 *  4 (full debug output)
*/
var ABLY_LOG_LEVEL = 'ABLY_LOG_LEVEL';
var ERRORS_AND_STATE_CHANGES = 2;
var DEBUG = 4;

var getLogLevel = exports.getLogLevel = function getLogLevel() {
  try {
    var parsedLevel = parseInt(window.localStorage.getItem(ABLY_LOG_LEVEL), 10);
    if (typeof parsedLevel === 'number' && !isNaN(parsedLevel)) {
      console.warn('[OVERRIDE] ABLY_LOG_LEVEL = ' + parsedLevel);
      return parsedLevel;
    }
  } catch (e) {
    /* do nothing */
  }

  return _enviro2.default.isQa() || !_enviro2.default.deployed() ? ERRORS_AND_STATE_CHANGES : DEBUG;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/operators/getLogLevel.js
// module id = 790
// module chunks = 2 3